const LAUNCH_STORAGE_KEY = "scratch-cg:launch-ticket";
const TICKET_PATTERN = /^[A-Za-z0-9_-]{43}$/u;

interface LaunchLocation {
    hash: string;
    pathname: string;
    search: string;
}

interface LaunchHistory {
    replaceState: (data: unknown, unused: string, url?: string | URL | null) => void;
}

type ReadStorage = Pick<Storage, "getItem">;
type WriteStorage = Pick<Storage, "getItem" | "removeItem" | "setItem">;

export const captureLaunchIntent = (
    location: LaunchLocation = window.location,
    history: LaunchHistory = window.history,
    storage: WriteStorage = window.sessionStorage,
    registerSensitive: (value: string) => void = () => undefined,
): string | undefined => {
    if (!location.hash) return readLaunchTicket(storage);
    const raw = location.hash.slice(1);
    const parameters = new URLSearchParams(raw);
    if (!parameters.has("launch")) return readLaunchTicket(storage);
    const ticket = parameters.get("launch") ?? "";
    const valid = parameters.size === 2 && parameters.get("v") === "1" && TICKET_PATTERN.test(ticket);

    history.replaceState(null, "", `${location.pathname}${location.search}`);
    if (!valid) {
        storage.removeItem(LAUNCH_STORAGE_KEY);
        return undefined;
    }
    registerSensitive(ticket);
    storage.setItem(LAUNCH_STORAGE_KEY, ticket);
    return ticket;
};

export const readLaunchTicket = (storage: ReadStorage = window.sessionStorage): string | undefined => {
    const ticket = storage.getItem(LAUNCH_STORAGE_KEY) ?? "";
    return TICKET_PATTERN.test(ticket) ? ticket : undefined;
};

export const clearLaunchTicket = (
    storage: Pick<Storage, "removeItem"> = window.sessionStorage,
): void => storage.removeItem(LAUNCH_STORAGE_KEY);
